import * as type from "./type";

const initialState = {
  stats: null,
  weeklyTickets: [],
  weeklyTotal: 0,
  openCategories: [],
  openCategoriesTotal: 0,
  recentTickets: [],
  activity: [],
  loading: false,
};

const VendorDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case type.GET_VENDOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload?.stats || null,
        weeklyTickets: action.payload?.weeklyTickets || [],
        weeklyTotal: action.payload?.weeklyTotal || 0,
        openCategories: action.payload?.openCategories || [],
        openCategoriesTotal: action.payload?.openCategoriesTotal || 0,
        recentTickets: action.payload?.recentTickets || [],
        activity: action.payload?.activity || [],
      };
    case type.GET_VENDOR_DASHBOARD_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default VendorDashboardReducer;
